module.exports = __webpack_public_path__ + "static/img/modeler-time.24691b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/modeler/modeler-time.jpg
// module id = Rp3L
// module chunks = 13